<template>
  <v-row v-if="symptom_checker.data != undefined && symptom_checker.data.length > 0" class="mt-5">
    <p>&nbsp;</p>
    <BR /><BR />
    <v-col cols="12">
      <h3 class="text--darken-1 mb-1" >
        Symptom Checker
      </h3>
      <!-- <span class="primary--text">{{ symptom_checker_reco }}</span> -->
    </v-col>

    <v-col cols="12">
      <v-data-table
      :items="symptom_checker.data"
      hide-default-footer
      class="sticky mt-5"
      :disable-sort="true"
      :headers="headers"
      :items-per-page="-1"
    >
      <template v-slot:item="{ item }">
      <tr>
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  {{ item.question.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title class="primary--text">
                  {{ getAnswerAsText(item.answer, item.question) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
        </tr>
      </template>
    </v-data-table>
    </v-col>

    <v-col cols="12">
      <span class="primary--text">Diagnosis</span>
    </v-col>
    <v-col v-if="symptom_diagnosis.length > 0" cols="12">
      <v-col cols="12" md="8" lg="8" xl="4" class="pl-5 mb-5" v-for="(diag, key) in symptom_diagnosis" :key="key">
        <v-row align="center" class="mb-0 ml-1">
          <span>{{ diag.text }}:</span> &nbsp; <span class="primary--text ml-3 font-weight-bold">{{ diag.value }}</span>
        </v-row>
      </v-col>
    </v-col>

    <v-col v-if="symptom_diagnosis.length == 0" cols="12">
      <v-col cols="12" class="pl-5 mb-5">
        <v-row align="center" class="mb-0 ml-1">
          <span>No Diagnosis Found</span>
        </v-row>
      </v-col>
    </v-col>
    <p>&nbsp;</p>
    <hr />
    <v-divider></v-divider>
    <p>&nbsp;</p>
    <BR /><BR />
  </v-row>
</template>

<script>
export default {
  name: 'SymptomChecker',
  computed: {
    symptom_checker() { console.log('symtom check: ', this.$store.getters['cases/symptom_checker']); return this.$store.getters['cases/symptom_checker'] },
    symptom_checker_reco () {
      if ( (this.symptom_checker.result != null || this.symptom_checker.result != undefined) && this.symptom_checker.result == 'Session not found' ) {
        return '';
      }
      return `(Recommendation: ${this.symptom_checker.recommendation})`;
    },
    symptom_diagnosis () {
      console.log('dddd: ', this.symptom_checker);
      if ( (this.symptom_checker.result != null || this.symptom_checker.result != undefined) && this.symptom_checker.result == 'Session not found' ) {
        return [];
      }

      if (this.symptom_checker.diagnoses == undefined || this.symptom_checker.diagnoses == null) {
        return [];
      }

      let diagnoses = Object.entries(this.symptom_checker.diagnoses);
      let parsed = [];
      for (let n in diagnoses) {
        parsed.push(
          {
            text: diagnoses[n][0],
            value: diagnoses[n][1],
          }
        )
      }
      return parsed;
    }
  },
  data () {
    return {
      headers: [
        { text: "Question", value: "question" },
        { text: "Answer", value: "answer", width: "200px"},
      ],
    }
  },
  methods: {
    getAnswerAsText (answer, question) {
      let answers = question.answers;

      if (question.inquiry.inquiry_type_id == 6) {
        return `${answer} out of ${question.max_value}`;
      } else {
        if ( !isNaN(answer) ) {
          let ansText = '';
          for (let ans in answers) {
            if (answers[ans].id == answer) {
              ansText = answers[ans].text; 
              break;
            }
          }
          return ansText;
        } else {
          return answer;
        }
      }

      
    }
  }
}
</script>
